import { base64ToBlob } from '@/utils/base64'
import { getBaseUrl } from '@/utils/baseUrl'
import http from '@/utils/http'
import { PATH_FILE } from './consts'

export const getImageUrl = () => {
  return `${PATH_FILE}/v1/download`
}

export const getDecryptImageUrl = () => {
  return `${PATH_FILE}/v1/download-decrypt`
}

export const getUploadUrl = () => {
  return `${getBaseUrl()}${PATH_FILE}/v1/upload`
}

export const getEncryptUploadUrl = () => {
  return `${getBaseUrl()}${PATH_FILE}/v1/upload-encrypt`
}

export const getImageViewUrl = (objectname: string) => {
  return `${getBaseUrl()}/presigned/v1/view?objectname=${objectname}`
}

export const uploadImageEncrypt = (file: string, encrypt: boolean = true) => {
  const Form = new FormData()
  Form.append('file', base64ToBlob(file), new Date().getTime() + '.jpg')
  Form.append('isGenerateFilename', 'true') // true：自动生成文件名   false：使用原文件名
  // Form.append('bucket', 'sensechess-dev')
  Form.append('folder', 'c1')
  return http.post(`${PATH_FILE}/v1/${encrypt ? 'upload-encrypt' : 'upload'}`, Form, {
    'Content-Type': 'multipart/form-data',
  })
}
